"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _BufferParameters = _interopRequireDefault(require("./BufferParameters"));

var _Position = _interopRequireDefault(require("../../geomgraph/Position"));

var _Coordinate = _interopRequireDefault(require("../../geom/Coordinate"));

var _BufferInputLineSimplifier = _interopRequireDefault(require("./BufferInputLineSimplifier"));

var _CoordinateArrays = _interopRequireDefault(require("../../geom/CoordinateArrays"));

var _OffsetSegmentGenerator = _interopRequireDefault(require("./OffsetSegmentGenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var OffsetCurveBuilder =
/*#__PURE__*/
function () {
  function OffsetCurveBuilder() {
    _classCallCheck(this, OffsetCurveBuilder);

    OffsetCurveBuilder.constructor_.apply(this, arguments);
  }

  _createClass(OffsetCurveBuilder, [{
    key: "getOffsetCurve",
    value: function getOffsetCurve(inputPts, distance) {
      this._distance = distance;
      if (distance === 0.0) return null;
      var isRightSide = distance < 0.0;
      var posDistance = Math.abs(distance);
      var segGen = this.getSegGen(posDistance);

      if (inputPts.length <= 1) {
        this.computePointCurve(inputPts[0], segGen);
      } else {
        this.computeOffsetCurve(inputPts, isRightSide, segGen);
      }

      var curvePts = segGen.getCoordinates();
      if (isRightSide) _CoordinateArrays.default.reverse(curvePts);
      return curvePts;
    }
  }, {
    key: "computeSingleSidedBufferCurve",
    value: function computeSingleSidedBufferCurve(inputPts, isRightSide, segGen) {
      var distTol = this.simplifyTolerance(this._distance);

      if (isRightSide) {
        segGen.addSegments(inputPts, true);

        var simp2 = _BufferInputLineSimplifier.default.simplify(inputPts, -distTol);

        var n2 = simp2.length - 1;
        segGen.initSideSegments(simp2[n2], simp2[n2 - 1], _Position.default.LEFT);
        segGen.addFirstSegment();

        for (var i = n2 - 2; i >= 0; i--) {
          segGen.addNextSegment(simp2[i], true);
        }
      } else {
        segGen.addSegments(inputPts, false);

        var simp1 = _BufferInputLineSimplifier.default.simplify(inputPts, distTol);

        var n1 = simp1.length - 1;
        segGen.initSideSegments(simp1[0], simp1[1], _Position.default.LEFT);
        segGen.addFirstSegment();

        for (var i = 2; i <= n1; i++) {
          segGen.addNextSegment(simp1[i], true);
        }
      }

      segGen.addLastSegment();
      segGen.closeRing();
    }
  }, {
    key: "computeRingBufferCurve",
    value: function computeRingBufferCurve(inputPts, side, segGen) {
      var distTol = this.simplifyTolerance(this._distance);
      if (side === _Position.default.RIGHT) distTol = -distTol;

      var simp = _BufferInputLineSimplifier.default.simplify(inputPts, distTol);

      var n = simp.length - 1;
      segGen.initSideSegments(simp[n - 1], simp[0], side);

      for (var i = 1; i <= n; i++) {
        var addStartPoint = i !== 1;
        segGen.addNextSegment(simp[i], addStartPoint);
      }

      segGen.closeRing();
    }
  }, {
    key: "computeLineBufferCurve",
    value: function computeLineBufferCurve(inputPts, segGen) {
      var distTol = this.simplifyTolerance(this._distance);

      var simp1 = _BufferInputLineSimplifier.default.simplify(inputPts, distTol);

      var n1 = simp1.length - 1;
      segGen.initSideSegments(simp1[0], simp1[1], _Position.default.LEFT);

      for (var i = 2; i <= n1; i++) {
        segGen.addNextSegment(simp1[i], true);
      }

      segGen.addLastSegment();
      segGen.addLineEndCap(simp1[n1 - 1], simp1[n1]);

      var simp2 = _BufferInputLineSimplifier.default.simplify(inputPts, -distTol);

      var n2 = simp2.length - 1;
      segGen.initSideSegments(simp2[n2], simp2[n2 - 1], _Position.default.LEFT);

      for (var i = n2 - 2; i >= 0; i--) {
        segGen.addNextSegment(simp2[i], true);
      }

      segGen.addLastSegment();
      segGen.addLineEndCap(simp2[1], simp2[0]);
      segGen.closeRing();
    }
  }, {
    key: "computePointCurve",
    value: function computePointCurve(pt, segGen) {
      switch (this._bufParams.getEndCapStyle()) {
        case _BufferParameters.default.CAP_ROUND:
          segGen.createCircle(pt);
          break;

        case _BufferParameters.default.CAP_SQUARE:
          segGen.createSquare(pt);
          break;
      }
    }
  }, {
    key: "getLineCurve",
    value: function getLineCurve(inputPts, distance) {
      this._distance = distance;
      if (distance < 0.0 && !this._bufParams.isSingleSided()) return null;
      if (distance === 0.0) return null;
      var posDistance = Math.abs(distance);
      var segGen = this.getSegGen(posDistance);

      if (inputPts.length <= 1) {
        this.computePointCurve(inputPts[0], segGen);
      } else {
        if (this._bufParams.isSingleSided()) {
          var isRightSide = distance < 0.0;
          this.computeSingleSidedBufferCurve(inputPts, isRightSide, segGen);
        } else this.computeLineBufferCurve(inputPts, segGen);
      }

      var lineCoord = segGen.getCoordinates();
      return lineCoord;
    }
  }, {
    key: "getBufferParameters",
    value: function getBufferParameters() {
      return this._bufParams;
    }
  }, {
    key: "simplifyTolerance",
    value: function simplifyTolerance(bufDistance) {
      return bufDistance * this._bufParams.getSimplifyFactor();
    }
  }, {
    key: "getRingCurve",
    value: function getRingCurve(inputPts, side, distance) {
      this._distance = distance;
      if (inputPts.length <= 2) return this.getLineCurve(inputPts, distance);

      if (distance === 0.0) {
        return OffsetCurveBuilder.copyCoordinates(inputPts);
      }

      var segGen = this.getSegGen(distance);
      this.computeRingBufferCurve(inputPts, side, segGen);
      return segGen.getCoordinates();
    }
  }, {
    key: "computeOffsetCurve",
    value: function computeOffsetCurve(inputPts, isRightSide, segGen) {
      var distTol = this.simplifyTolerance(this._distance);

      if (isRightSide) {
        var simp2 = _BufferInputLineSimplifier.default.simplify(inputPts, -distTol);

        var n2 = simp2.length - 1;
        segGen.initSideSegments(simp2[n2], simp2[n2 - 1], _Position.default.LEFT);
        segGen.addFirstSegment();

        for (var i = n2 - 2; i >= 0; i--) {
          segGen.addNextSegment(simp2[i], true);
        }
      } else {
        var simp1 = _BufferInputLineSimplifier.default.simplify(inputPts, distTol);

        var n1 = simp1.length - 1;
        segGen.initSideSegments(simp1[0], simp1[1], _Position.default.LEFT);
        segGen.addFirstSegment();

        for (var i = 2; i <= n1; i++) {
          segGen.addNextSegment(simp1[i], true);
        }
      }

      segGen.addLastSegment();
    }
  }, {
    key: "getSegGen",
    value: function getSegGen(distance) {
      return new _OffsetSegmentGenerator.default(this._precisionModel, this._bufParams, distance);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return OffsetCurveBuilder;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "copyCoordinates",
    value: function copyCoordinates(pts) {
      var copy = new Array(pts.length).fill(null);

      for (var i = 0; i < copy.length; i++) {
        copy[i] = new _Coordinate.default(pts[i]);
      }

      return copy;
    }
  }]);

  return OffsetCurveBuilder;
}();

exports.default = OffsetCurveBuilder;

OffsetCurveBuilder.constructor_ = function () {
  this._distance = 0.0;
  this._precisionModel = null;
  this._bufParams = null;
  var precisionModel = arguments[0],
      bufParams = arguments[1];
  this._precisionModel = precisionModel;
  this._bufParams = bufParams;
};